var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as StringUtils from '../utils/string';
import { Injectable } from '@angular/core';
import { EventName, Events } from '../utils/events';
import { API } from './api';
import { BaseProvider } from './base';
import { BugsnagProvider } from './bugsnag';
export var AnomalyMode;
(function (AnomalyMode) {
    AnomalyMode["None"] = "none";
    AnomalyMode["Normal"] = "normal";
    AnomalyMode["Anomaly"] = "anomaly";
})(AnomalyMode || (AnomalyMode = {}));
export var NOTHING_I_KNOW_IDENTIFIER = 'nothing-i-know-identifier';
// This is the renamed NiK, the actual one is "Nothing I know"
export var CLASS_NAME_NOTHING_I_KNOW = 'Nothing I Know';
export var CLASS_NAME_NORMAL = 'Normal';
export var CLASS_NAME_ANOMALY = 'Anomaly';
var ClassProvider = /** @class */ (function (_super) {
    __extends(ClassProvider, _super);
    function ClassProvider(api, bugSnag, events) {
        var _this = _super.call(this) || this;
        _this.api = api;
        _this.bugSnag = bugSnag;
        _this.events = events;
        _this.classes = [];
        _this.classesIndex = {};
        // We're only expecting a max of 10 classes for now
        _this.colorChoices = [
            '#FC4E1F',
            '#FD8925',
            '#FDBE2C',
            '#1B9D17',
            '#89C541',
            '#CDDE20',
            '#273891',
            '#2765FB',
            '#2CA1FC',
            '#FF5F97'
        ];
        _this.THRESHOLD = 20;
        return _this;
    }
    /**
     * Gets n classes
     * @param limit: The number of classes you want
     * Leave this blank to get all classes
     */
    ClassProvider.prototype.getClasses = function (limit) {
        if (limit === void 0) { limit = this.classes.length; }
        if (limit) {
            return this.classes.slice(0, limit);
        }
        else {
            return this.classes;
        }
    };
    ClassProvider.prototype.getUniqueClassNames = function (allowWhitespace) {
        if (allowWhitespace === void 0) { allowWhitespace = true; }
        var names = this.getClasses().map(function (c) { return c.name; });
        // We don't allow detection datasets to use class names with white space,
        // so we need to remove them from typeaheads.
        if (!allowWhitespace) {
            names = names.filter(function (name) { return !name.includes(' '); });
        }
        return Array.from(new Set(names));
    };
    ClassProvider.prototype.getDatasetClasses = function (datasetIdentifier) {
        return this.classes.filter(function (c) { return c.datasetIdentifier == datasetIdentifier; });
    };
    ClassProvider.prototype.getDatasetClassNameMap = function (datasetIdentifier) {
        var map = {};
        for (var _i = 0, _a = this.classes; _i < _a.length; _i++) {
            var classObj = _a[_i];
            if (classObj.datasetIdentifier == datasetIdentifier) {
                map[classObj.name] = classObj;
            }
        }
        return map;
    };
    /**
     * Return a list of classes that are available for use in the current dataset.
     * @param datasetIdentifier {string} Unique identifier for the dataset
     * @param allowWhitespace {boolean} Include class names with spaces inside them (false for detection, true for other datasets)
     * @param allowExactMatch {boolean} Allow case-sensitive matches; required if the user is allowed to assign
     * an existing class to an asset (i.e if they're batch-tagging or uploading new assets).
     */
    ClassProvider.prototype.getAllowedClassNamesForDataset = function (datasetIdentifier, allowWhitespace, allowExactMatch) {
        var _this = this;
        if (allowWhitespace === void 0) { allowWhitespace = true; }
        if (allowExactMatch === void 0) { allowExactMatch = false; }
        var allClassNames = this.getUniqueClassNames(allowWhitespace);
        // This used to be a Map object, but the key-value structure of a map or similar object doesn't play well with
        // case-insensitive comparisons.
        var datasetClassNames = this.getDatasetClasses(datasetIdentifier).map(function (datasetClass) { return datasetClass.name; });
        var caseInsensitiveNames = datasetClassNames.map(function (name) { return _this.getCaseInsensitiveClassName(name); });
        var allowedClassNames = allClassNames.filter(function (name) {
            var isCaseInsensitiveMatch = caseInsensitiveNames.indexOf(_this.getCaseInsensitiveClassName(name)) >= 0;
            var isExactMatch = allowExactMatch ? datasetClassNames.indexOf(name) >= 0 : false;
            return !isCaseInsensitiveMatch || isExactMatch;
        });
        return allowedClassNames;
    };
    ClassProvider.prototype.getCaseInsensitiveClassName = function (className) {
        return className.toLowerCase().trim();
    };
    ClassProvider.prototype.getClassByID = function (id) {
        var location = this.classesIndex[id];
        return this.classes[location];
    };
    /**
     * Find a class by name
     * @param name
     */
    ClassProvider.prototype.getClassByName = function (name) {
        var lowerName = name.toLowerCase();
        for (var _i = 0, _a = this.classes; _i < _a.length; _i++) {
            var c = _a[_i];
            if (c.name.toLowerCase() == lowerName) {
                return c;
            }
        }
    };
    ClassProvider.prototype.fetchClasses = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var result, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.get('classes')];
                    case 1:
                        result = _a.sent();
                        this.classes = result.message.map(function (obj, index) {
                            _this.classesIndex[obj.classIdentifier] = index;
                            return {
                                id: obj.classIdentifier,
                                name: obj.name,
                                color: obj.color || _this.colorChoices[index % _this.colorChoices.length],
                                datasetIdentifier: obj.datasetIdentifier
                            };
                        });
                        return [2 /*return*/, this.classes];
                    case 2:
                        err_1 = _a.sent();
                        throw err_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ClassProvider.prototype.load = function (force) {
        if (force === void 0) { force = false; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.ensureLoaded(function () { return _this.fetchClasses(); }, force)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ClassProvider.prototype.reloadClasses = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetchClasses()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Randomly generate a hex color
     * Source: https://www.paulirish.com/2009/random-hex-color-code-snippets/
     * Uses fix that avoids trailing zeros and biasing the results towards green
     */
    ClassProvider.prototype.randomHexColor = function () {
        return "#" + (Math.random().toString(16) + "000000").slice(2, 8);
    };
    ClassProvider.prototype.emitClassesChanged = function () {
        this.events.publish(EventName.ClassChanged);
    };
    /**
     * Add a new class
     *
     * @param name The class name
     * @param datasetIdentifier the dataset the class is to be added to
     * @param color The class color.  Optional
     */
    ClassProvider.prototype.addClass = function (name, datasetIdentifier, color) {
        if (color === void 0) { color = null; }
        return __awaiter(this, void 0, void 0, function () {
            var result, classObj, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!name) {
                            this.bugSnag.logError("Invalid class name: " + name);
                            return [2 /*return*/, null];
                        }
                        if (!datasetIdentifier) {
                            this.bugSnag.logError("Invalid dataset identifier: " + datasetIdentifier);
                            return [2 /*return*/, null];
                        }
                        // Users can have classes with the same name and different capitalization across all their datasets,
                        // but not within the same dataset. Exact capitalization matches are blocked at the UX level.
                        if (this.getDatasetClasses(datasetIdentifier)
                            .map(function (_a) {
                            var name = _a.name;
                            return name.toLowerCase();
                        })
                            .indexOf(name.toLowerCase()) >= 0) {
                            this.bugSnag.logInfo("Class of name " + name + " already exists in dataset " + datasetIdentifier);
                            return [2 /*return*/, null];
                        }
                        /**
                         * If user wants to add a class without a color
                         * try and select a color based on which preset
                         * colors are still available
                         */
                        if (!color) {
                            color = this.getNextUnusedColor(datasetIdentifier);
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.api.post("datasets/" + datasetIdentifier + "/classes", {
                                classes: [{ name: name.trim(), color: color }]
                            })];
                    case 2:
                        result = _a.sent();
                        classObj = {
                            id: result.message[0].classIdentifier,
                            name: result.message[0].name,
                            color: result.message[0].color,
                            datasetIdentifier: datasetIdentifier
                        };
                        this.classes.push(classObj);
                        this.classesIndex[classObj.id] = this.classes.length - 1;
                        this.emitClassesChanged();
                        return [2 /*return*/, classObj];
                    case 3:
                        err_2 = _a.sent();
                        throw err_2;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ClassProvider.prototype.addClasses = function (datasetIdentifier, classDescriptions) {
        return __awaiter(this, void 0, void 0, function () {
            var result, _i, _a, row, classObj, err_3;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.post("datasets/" + datasetIdentifier + "/classes", {
                                classes: classDescriptions
                            })];
                    case 1:
                        result = _b.sent();
                        for (_i = 0, _a = result.message; _i < _a.length; _i++) {
                            row = _a[_i];
                            classObj = {
                                id: result.message[0].classIdentifier,
                                name: result.message[0].name,
                                color: result.message[0].color,
                                visible: true,
                                datasetIdentifier: datasetIdentifier
                            };
                            this.classes.push(classObj);
                            this.classesIndex[classObj.id] = this.classes.length - 1;
                        }
                        this.emitClassesChanged();
                        return [3 /*break*/, 3];
                    case 2:
                        err_3 = _b.sent();
                        throw err_3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Searchs a the classes array and returns
     * the classes that match the search query
     * @param query: The string to search for
     * @param limit: Limit the number of classes in the response
     */
    ClassProvider.prototype.searchClasses = function (query, limit) {
        var items = this.classes;
        if (query) {
            query = query.toLowerCase();
            items = this.classes.filter(function (c) { return c.name.toLowerCase().includes(query); });
        }
        if (limit > items.length) {
            return items;
        }
        else {
            return items.slice(0, limit);
        }
    };
    /**
     * Removes class information for the user
     */
    ClassProvider.prototype.resetInfo = function () {
        this.classes = [];
        this.classesIndex = {};
        _super.prototype.resetInfo.call(this);
    };
    ClassProvider.prototype.getUsedColors = function (datasetIdentifier) {
        var usedColors = {};
        // Build up a map of all used colors
        this.getDatasetClasses(datasetIdentifier).forEach(function (obj) {
            if (obj.color) {
                usedColors[obj.color.toLowerCase()] = true;
            }
        });
        return usedColors;
    };
    ClassProvider.prototype.updateColor = function (classObject, color) {
        return __awaiter(this, void 0, void 0, function () {
            var err_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        this.emitClassesChanged();
                        return [4 /*yield*/, this.api.post("classes/" + classObject.id + "/color", {
                                color: color
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        err_4 = _a.sent();
                        throw err_4;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ClassProvider.prototype.getColors = function () {
        return this.colorChoices;
    };
    ClassProvider.prototype.getNextAvailableColor = function (datasetIdentifier) {
        var usedColors = this.getUsedColors(datasetIdentifier);
        for (var index in this.colorChoices) {
            if (!usedColors[this.colorChoices[index].toLowerCase()]) {
                return this.colorChoices[index];
            }
        }
        return this.randomHexColor();
    };
    ClassProvider.prototype.getNextRandomColor = function (datasetIdentifier) {
        var usedColors = this.getUsedColors(datasetIdentifier);
        var newRandomColor = this.randomHexColor();
        // loop until the random color has not been used.
        while (usedColors[newRandomColor.toLowerCase()]) {
            newRandomColor = this.randomHexColor();
        }
        return newRandomColor;
    };
    ClassProvider.prototype.getNextUnusedColor = function (datasetIdentifier) {
        var color = this.getNextAvailableColor(datasetIdentifier);
        if (!color) {
            color = this.getNextRandomColor(datasetIdentifier);
        }
        return color;
    };
    /**
     * Rename class
     * @param classIdentifier class identifier
     * @param newName new name for class
     */
    ClassProvider.prototype.renameClass = function (newName, classIdentifier) {
        return __awaiter(this, void 0, void 0, function () {
            var err_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.post("classes/" + classIdentifier + "/rename", {
                                name: newName
                            })];
                    case 1:
                        _a.sent();
                        this.emitClassesChanged();
                        return [3 /*break*/, 3];
                    case 2:
                        err_5 = _a.sent();
                        throw err_5;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Delete a class
     * @param classIdentifier class identifier
     */
    ClassProvider.prototype.deleteClass = function (classObj) {
        return __awaiter(this, void 0, void 0, function () {
            var err_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.delete("classes/" + classObj.id)];
                    case 1:
                        _a.sent();
                        this.classes.splice(this.classes.indexOf(classObj), 1);
                        this.generateClassIndex();
                        this.emitClassesChanged();
                        return [3 /*break*/, 3];
                    case 2:
                        err_6 = _a.sent();
                        throw err_6;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ClassProvider.prototype.generateClassIndex = function () {
        var _this = this;
        this.classesIndex = {};
        this.classes.forEach(function (cls, index) {
            _this.classesIndex[cls.id] = index;
        });
    };
    ClassProvider.prototype.batchDelete = function (datasetIdentifier, assetIdentifiers) {
        return __awaiter(this, void 0, void 0, function () {
            var err_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.post('assets/deletes', {
                                datasetIdentifier: datasetIdentifier,
                                assetIdentifiers: assetIdentifiers
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        err_7 = _a.sent();
                        throw err_7;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ClassProvider.prototype.batchTag = function (datasetIdentifier, assetIdentifiers, classIdentifier) {
        return __awaiter(this, void 0, void 0, function () {
            var err_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.post('assets/recognition/tags', {
                                datasetIdentifier: datasetIdentifier,
                                assetIdentifiers: assetIdentifiers,
                                untagged: false,
                                classIdentifier: classIdentifier
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        err_8 = _a.sent();
                        throw err_8;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // When attempting to create a new class, we should check to make
    // sure we're not duplicating a pre-existing class name.
    ClassProvider.prototype.canAddClassToDataset = function (newClassName, datasetIdentifier, allowWhitespace) {
        if (allowWhitespace === void 0) { allowWhitespace = true; }
        var uniqueClassNames = this.getUniqueClassNames(allowWhitespace);
        var classesInDataset = this.getDatasetClasses(datasetIdentifier).map(function (neuralaClass) { return neuralaClass.name; });
        // Users should be able to create a class if:
        // 1. They have no classes in their current dataset that match the new class's name, but may have different capitalization.
        if (classesInDataset && classesInDataset.length > 0) {
            if (StringUtils.isStringInArray(newClassName, classesInDataset, false)) {
                return false;
            }
        }
        // 2. They have no classes anywhere in their account/organization that
        // exactly match the new class's name, including capitalization.
        if (StringUtils.isStringInArray(newClassName, uniqueClassNames, true)) {
            return false;
        }
        return true;
    };
    /**
     * Generate a fallback class object
     * This is useful when we need to represent a class object but that class has been deleted from the dataset
     */
    ClassProvider.prototype.getFallbackClassObj = function (name, datasetIdentifier) {
        if (datasetIdentifier === void 0) { datasetIdentifier = null; }
        return {
            name: name,
            id: 'unknown',
            datasetIdentifier: datasetIdentifier || 'unknown',
            color: datasetIdentifier ? this.getNextUnusedColor(datasetIdentifier) : this.randomHexColor()
        };
    };
    /**
     * Generate an array of ClassThreshold objects, one for each trained class
     */
    ClassProvider.prototype.getClassThresholds = function (datasetIdentifier, brainEnvClasses, defaultConfidenceThreshold) {
        var classThresholds = [];
        var classMap = this.getDatasetClassNameMap(datasetIdentifier);
        for (var _i = 0, brainEnvClasses_1 = brainEnvClasses; _i < brainEnvClasses_1.length; _i++) {
            var classEnv = brainEnvClasses_1[_i];
            var classObj = classMap[classEnv.name];
            if (!classObj) {
                classObj = this.getFallbackClassObj(classEnv.name, datasetIdentifier);
            }
            classThresholds.push({
                name: classEnv.name,
                color: classObj.color,
                confidenceThreshold: classEnv.confidenceThreshold || defaultConfidenceThreshold
            });
        }
        return classThresholds;
    };
    ClassProvider.prototype.getNothingIKnowClass = function (datasetIdentifier) {
        return {
            name: CLASS_NAME_NOTHING_I_KNOW,
            color: '',
            id: NOTHING_I_KNOW_IDENTIFIER,
            datasetIdentifier: datasetIdentifier
        };
    };
    /**
     * Return true if the specified class name matches the nothing-i-know
     * class name.
     *
     * @param className Name of the class to check
     * @param caseSensitive Specify false to allow a case-insensitive match
     */
    ClassProvider.prototype.isClassNothingIKnow = function (className, caseSensitive) {
        if (caseSensitive === void 0) { caseSensitive = true; }
        return this.compareClassNames(className, CLASS_NAME_NOTHING_I_KNOW, caseSensitive);
    };
    /**
     * Return true if the specified class name matches the anomaly recognition Normal
     * class name.
     *
     * @param className Name of the class to check
     * @param caseSensitive Specify false to allow a case-insensitive match
     */
    ClassProvider.prototype.isClassNormal = function (className, caseSensitive) {
        if (caseSensitive === void 0) { caseSensitive = true; }
        return this.compareClassNames(className, CLASS_NAME_NORMAL, caseSensitive);
    };
    /**
     * Return true if the specified class name matches the anomaly recognition Anomaly
     * class name.
     *
     * @param className Name of the class to check
     * @param caseSensitive Specify false to allow a case-insensitive match
     */
    ClassProvider.prototype.isClassAnomaly = function (className, caseSensitive) {
        if (caseSensitive === void 0) { caseSensitive = true; }
        return this.compareClassNames(className, CLASS_NAME_ANOMALY, caseSensitive);
    };
    /**
     * Return true if the specified actualClassName matches the specified
     * expectedClassName. Both actualClassName and expectedClassName must
     * have a non-nullish value
     *
     * @param actualClassName Name of the class to check
     * @param expectedClassName Name of the expected class
     * @param caseSensitive Specify false to allow a case-insensitive match
     */
    ClassProvider.prototype.compareClassNames = function (actualClassName, expectedClassName, caseSensitive) {
        if (caseSensitive === void 0) { caseSensitive = true; }
        if (!actualClassName || !expectedClassName) {
            return false;
        }
        if (caseSensitive) {
            return actualClassName === expectedClassName;
        }
        return actualClassName.toLowerCase() === expectedClassName.toLowerCase();
    };
    ClassProvider = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [API, BugsnagProvider, Events])
    ], ClassProvider);
    return ClassProvider;
}(BaseProvider));
export { ClassProvider };
//# sourceMappingURL=class.js.map


// WEBPACK FOOTER //
// ./src/providers/class.ts.pre-build-optimizer.js